<template>
  <div class="top-section">
    <div class="top-section__image">
      <picture v-if="data.image1">
        <source v-if="data.image1_mob_webp"
                :srcset="data.image1_mob_webp"
                type="image/webp"
                media="(max-width: 500px)" >
        <source v-if="data.image1_mob"
                :srcset="data.image1_mob"
                media="(max-width: 500px)" >
        <source v-if="data.image1_tablet_webp"
                :srcset="data.image1_tablet_webp"
                type="image/webp"
                media="(max-width: 767px)" >
        <source v-if="data.image1_tablet"
                :srcset="data.image1_tablet"
                media="(max-width: 767px)" >
        <source v-if="data.image1_small_pc_webp"
                :srcset="data.image1_small_pc_webp"
                type="image/webp"
                media="(max-width: 1023px)" >
        <source v-if="data.image1_small_pc"
                :srcset="data.image1_small_pc"
                media="(max-width: 1023px)" >
        <source v-if="data.image1_pc_webp"
                :srcset="data.image1_pc_webp"
                type="image/webp"
                media="(max-width: 1365px)" >
        <source v-if="data.image1_pc"
                :srcset="data.image1_pc"
                media="(max-width: 1365px)" >
        <source v-if="data.image1_webp"
                :srcset="data.image1_webp"
                type="image/webp">
        <img :src="data.image1"
             :title="createTitleMixin(data.title1)"
             :alt="createAltMixin(data.title1)">
      </picture>
    </div>
    <div class="top-section__text">
      <div class="top-section__text-item">
        <h1 class="top-section__title">{{data.title1}}</h1>
        <div class="top-section__subtitle">{{data.text1}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TopSection',
    props: {
      data: Object
    }
  }
</script>

<style>

</style>
